import React, { Fragment } from 'react'
import {
  Heading,
  Flex,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  Box,
  Stack,
  VStack,
  Link,
  Text,
} from '@chakra-ui/react'
import { NextSeo } from 'next-seo'

import { Footer, Header, Blog, Contact } from '@/components/Landing'
import { Container, Background } from '@/components/Landing/shared'
import withPage from '@/lib/page/withPage'
import { mq } from '@/lib/responsive'

import { questionGroups } from './constant'

function FAQ() {
  return (
    <Fragment>
      <NextSeo title="FAQ" />

      <div css={{ overflow: 'hidden' }}>
        <Header isAltStyle />
        <Flex
          justifyContent="center"
          alignItems="center"
          mt="60px"
          pos="relative"
          css={{
            width: '100%',
            height: 132,
            [mq('sm')]: { height: 180 },
            [mq('md+')]: { height: 356 },
          }}
        >
          <Background src="/images/Landing/faq-mask.jpg" />
          <Heading
            as="h1"
            color="#ffffff"
            fontWeight="500"
            css={{
              fontSize: 24,
              [mq('sm')]: { fontSize: 32 },
            }}
          >
            คำถามที่พบบ่อย (FAQs)
          </Heading>
        </Flex>
        <Container
          css={{ display: 'grid', padding: '32px 0', fontWeight: 300, gap: 32 }}
        >
          {questionGroups.map(({ title, questions }, groupIndex) => (
            <Box key={`group-${groupIndex}`}>
              <Heading
                as="h2"
                fontWeight="500"
                css={{
                  fontSize: 20,
                  margin: '18px 0',
                  [mq('sm')]: { fontSize: 24 },
                }}
              >
                {title}
              </Heading>
              <Accordion allowToggle defaultIndex={[]}>
                {questions.map(({ question, answer }, questionIndex) => (
                  <AccordionItem
                    key={`question-${groupIndex}-${questionIndex}`}
                  >
                    <AccordionButton
                      fontWeight="300"
                      minH="64px"
                      _expanded={{ bg: '#e8e8e8', fontWeight: 500 }}
                    >
                      <Box flex="1" textAlign="left">
                        {question}
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                    <AccordionPanel pb={4}>{answer}</AccordionPanel>
                  </AccordionItem>
                ))}
              </Accordion>
            </Box>
          ))}
          <VStack>
            <Stack
              direction={{
                base: 'column',
                lg: 'row',
              }}
            >
              <Text>หากต้องการข้อมูล อ่านเพิ่มเติมได้ที่</Text>{' '}
              <Link
                isExternal
                href="https://help.pdpa.pro/th/"
                sx={{ fontWeight: 'medium', textAlign: 'center' }}
              >
                ศูนย์ช่วยเหลือผู้ใช้งาน
              </Link>
            </Stack>
          </VStack>
        </Container>
        <Blog />
        <Contact />
        <Footer />
      </div>
    </Fragment>
  )
}

export default withPage()(FAQ)
